import { Component } from 'react';

import { HtmlEntityTypes } from '../../../utils/icon.utils';

export default class FeaturesTilesComponent extends Component<{ features: any }> {

    getHtmlEntityForFeatureIcon(iconName: string) {
        switch (iconName) {
            case 'lightbulb_outline':
                return HtmlEntityTypes.BULB;
            case 'star_rate':
                return HtmlEntityTypes.STAR;
            case 'airplanemode_active':
                return HtmlEntityTypes.AIRPLANE;
            case 'desktop_windows':
                return HtmlEntityTypes.DESKTOP_COMPUTER;
            case 'lock':
                return HtmlEntityTypes.PADLOCK_CLOSE;
            case 'cloud_upload':
                return HtmlEntityTypes.CLOUD;

        }
        return HtmlEntityTypes.STAR;
    }

    render() {
        return <div className="section">
            <div className="row">
                {
                    this.props.features && this.props.features.map((feature, index) => {
                        return <div key={`feature-${index}`} className="col-12 col-sm-12 col-md-6 col-lg-4 feature">
                            <div className="icon">
                                <span style={{ fontSize: '2rem' }} dangerouslySetInnerHTML={{ __html: this.getHtmlEntityForFeatureIcon(feature.icon) }}></span>
                            </div>
                            <h4 className="title ellipsis">{feature.title}</h4>
                            <p className="description" dangerouslySetInnerHTML={{ __html: feature.description }}></p>
                        </div>;
                    })
                }
            </div>
        </div>
    }
}